import { render } from "./BaseConfig.vue?vue&type=template&id=7cb8706f&scoped=true"
import script from "./BaseConfig.vue?vue&type=script&lang=js"
export * from "./BaseConfig.vue?vue&type=script&lang=js"

import "./BaseConfig.vue?vue&type=style&index=0&id=7cb8706f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb8706f"]])

export default __exports__